import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import cn from 'classnames';
import TableHead from './TableHead';
import TableRow from './TableRow';
import { FCX } from "@datassential/platform-ui-lib";

interface TableProps {
    isLoading?: boolean;
    rowsCount: number;
    headHeight?: number;
    rowHeight?: number;
    noHeader?: boolean;
    showFallback?: boolean;
    dataLength?: number;
}

const Table: FCX<TableProps> = ({
    isLoading,
    rowsCount,
    headHeight = 38,
    rowHeight = 38,
    noHeader = false,
    showFallback,
    style,
    className,
    children,
    testId,
    dataLength,
}) => {
    const data = useMemo(
        () => new Array(rowsCount).fill(0).map(() => uuid()),
        [rowsCount]
    );

    const defaultFallback = useMemo(
        () => {
            if (rowsCount === 0 && !isLoading && showFallback) {
                return (
                    <div className='Table__fallback-wrapper'>
                        <span className="Table__fallback">No matching items found</span>
                    </div>
                );
            }

            return null;
        },
        [rowsCount, isLoading, showFallback]
    );

    return (
        <div
            className={cn('Table', className)}
            style={style}
            data-testid={testId}
        >
            {!noHeader && <TableHead height={headHeight}/>}
            {data.map((row, index) => {
                const isRowLoading = isLoading && (dataLength === undefined || index >= dataLength);
                return (
                    <TableRow
                        key={row}
                        index={index}
                        isLoading={isRowLoading}
                        testId={`tableRow${index}`}
                        style={{
                            height: rowHeight,
                        }}
                    />
                );
            })}
            {defaultFallback}
            {children}
        </div>
    );
};

export default Table;
